import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';

class WarehouseLabelApi {
    constructor() {
        this.baseUrl = 'api/warehouse/v1/label/';
    }

    async getCaseLabels({ lotID, palletID, qty }) {
        let url = `${this.baseUrl}case`;
        if (lotID) {
            url += `?lotID=${lotID}`;
            if (qty) {
                url += `&qty=${qty}`;
            }
        } else if (palletID) {
            url += `?palletID=${palletID}`;
        }

        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                return blob;
            }
        } catch (e) {
            logError(e);
        }
        return undefined;
    }

    async getPalletLabelsByLotId({ includeEmptyCases = false, lotId, qty }) {
        const url = `${this.baseUrl}pallet?lotId=${lotId}&qty=${qty}&includeEmptyCases=${includeEmptyCases}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                return blob;
            }
        } catch (e) {
            logError(e);
        }
        return undefined;
    }

    async getPalletLabels({ palletID, qty = 1 }) {
        const url = `${this.baseUrl}pallet?id=${palletID}&qty=${qty}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                return blob;
            }
        } catch (e) {
            logError(e);
        }
        return undefined;
    }

    async getMultiplePalletLabels(palletIds, qty) {
        const palletIdString = palletIds.join(',');
        let url = `${this.baseUrl}pallet?ids=${palletIdString}`;
        if (qty != null) {
            url += `&qty=${qty}`;
        }
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                return blob;
            }
        } catch (e) {
            logError(e);
        }
        return undefined;
    }
}

export { WarehouseLabelApi };
